import axios from 'utils/axios';
import { AxiosResponse, isAxiosError } from 'axios';
import getCategoriesServiceMock from 'store/slices/mocks/getCategoriesServiceMock';
import getFacetsServiceMock from 'store/slices/mocks/getFacetsServiceMock';
import { BrandsType, BrandType } from 'types/components/shared';
import { CreateBrandProps, CreateBrandResponseType } from 'services/catalog.types';
import { ApiResponse } from 'types';
import { AprovalSupplierType, ProfileSupplierType } from 'types/catalog';

/* ============ BRANDS ============ */

export const getBrandsService = async ({
    idMerchant
}: {
    idMerchant?: number | string;
}): Promise<AxiosResponse<ApiResponse<BrandsType[]>>> => {
    try {
        const bodyMerchant = {};
        const response = await axios.post(`/loolu/api/brand/search-multicatalog`, bodyMerchant, {
            params: { idMerchant }
        });
        return response;
    } catch (err: any) {
        if (isAxiosError(err)) {
            console.error('Axios error in getBrandsService:', err.response?.status, err.message);
        } else {
            console.error('Unexpected error in getBrandsService:', err);
        }
        throw err;
    }
};

export const editBrandService = async ({ dataBrand, idMerchant }: { dataBrand: BrandType; idMerchant: number | string }) => {
    try {
        const response = await axios.post(`/loolu/api/brand/create`, dataBrand, {
            params: { idMerchant }
        });
        return response.data;
    } catch (err: any) {
        if (isAxiosError(err)) {
            console.error('Axios error in editBrandService:', err.response?.status, err.message);
        } else {
            console.error('Unexpected error in editBrandService:', err);
        }
        throw err;
    }
};

export const createBrandService = async (
    dataBrand: CreateBrandProps | CreateBrandProps[]
): Promise<AxiosResponse<ApiResponse<CreateBrandResponseType[]>>> => {
    try {
        const bodyData = Array.isArray(dataBrand) ? dataBrand : [dataBrand];
        let idMerchant;
        if (Array.isArray(dataBrand)) {
            idMerchant = dataBrand[0]?.idMerchant;
        } else {
            idMerchant = dataBrand?.idMerchant;
        }
        const response = await axios.post(`/loolu/api/brand/save-multicatalog`, bodyData, {
            params: { idMerchant }
        });
        return response;
    } catch (err: any) {
        if (isAxiosError(err)) {
            console.error('Axios error in createBrandService:', err.response?.status, err.message);
        } else {
            console.error('Unexpected error in createBrandService:', err);
        }
        throw err;
    }
};

/* ============ VENDORS ============ */
/** DEPRECATED */
export const getVendorsMulticatalogService = async ({
    idMerchant,
    idProvider
}: {
    idMerchant?: number | string;
    idProvider?: number | string;
}): Promise<AxiosResponse<ApiResponse<any[]>>> => {
    try {
        const response = await axios.get(`/loolu/api/multicatalog/supplier/search`, {
            params: { idMerchant, idProvider }
        });

        return response;
    } catch (err: any) {
        if (isAxiosError(err)) {
            console.error('Axios error in getVendorsService:', err.response?.status, err.message);
        } else {
            console.error('Unexpected error in getVendorsService:', err);
        }
        throw err;
    }
};

export const getTotalVendorsService = async ({
    merchantId,
    statusId,
    email
}: {
    merchantId?: number | string;
    statusId?: number | string;
    email?: string;
}): Promise<AxiosResponse<ApiResponse<any[]>>> => {
    try {
        const response = await axios.get(`/loolu/api/approval/totalVendors`, {
            params: { merchantId, statusId, email }
        });
        return response;
    } catch (err: any) {
        if (isAxiosError(err)) {
            console.error('Axios error in getVendorsService:', err.response?.status, err.message);
        } else {
            console.error('Unexpected error in getVendorsService:', err);
        }
        throw err;
    }
};

export const getRolesService = async (): Promise<
    AxiosResponse<{
        profile: ProfileSupplierType[];
        approval: AprovalSupplierType[];
    }>
> => {
    try {
        const response = await axios.get(`/loolu/api/catalog/pub/profiles`);
        return response;
    } catch (err: any) {
        if (isAxiosError(err)) {
            console.error('Axios error in getRolesService:', err.response?.status, err.message);
        } else {
            console.error('Unexpected error in getRolesService:', err);
        }
        throw err;
    }
};

/* ============ FACETS ============ */

export const getFacetsService = async ({ term, page, idMerchant }: any) => {
    try {
        const response = await axios.get(`/loolu/api/facets/raw-multicatalog/merchant/${idMerchant}/search`, {
            params: {
                searchParam: term,
                pageNum: page
            }
        });
        const result = response.data;
        return result?.response?.map((item: any) => ({ ...item, totalPages: result?.totalPages }));
    } catch (err: any) {
        console.warn('Using fallback for getFacetsService');
        return getFacetsServiceMock;
    }
};

export const editFacetService = async ({ idMerchant, data }: any) => {
    try {
        const response = await axios.put(`/loolu/api/facets/raw/merchant/${idMerchant}`, [data]);
        return response.data;
    } catch (err: any) {
        if (isAxiosError(err)) {
            console.error('Axios error in editFacetService:', err.response?.status, err.message);
        } else {
            console.error('Unexpected error in editFacetService:', err);
        }
        throw err;
    }
};

/* ============ CATEGORIES ============ */

export const getCategoriesService = async (idMerchant: number | string) => {
    try {
        const response = await axios.get(`/loolu/api/category/search-multicatalog`, {
            params: {
                idMerchant // TODO: QUITAR este parametro
            }
        });
        return response.data;
    } catch (err: any) {
        console.warn('Using fallback for getCategoriesService');
        return getCategoriesServiceMock;
    }
};
